import models from './legacyEngineModels';
import _ from 'lodash';

var Topic = models.Topic;


// curCard is a Question object
// check if answer is correct, then grade and score question and the overall learning activity
export function checkAnswer(score) {

    var isCorrect = false;
    if (score.curCard.questionType === 'FB') {
        score.curCard.answered.push(score.curCard.userAnswerIndex);
        isCorrect = evaluateFbAnswer(score.curCard);
    }
    else {
        score.curCard.answered.push(score.curCard.userAnswerIndex);
        isCorrect = evaluateMcScAnswer(score.curCard);
    }

    if (isCorrect) {
        gradeAndScoreCorrectAnswer(score);
    }
    else {
        gradeAndScoreWrongAnswer(score);
    }

    return isCorrect;
}

export function gradeAndScoreCorrectAnswer(score) {
    // check time taken to answer the question
    checkQuestionTime(score,  (score.curCard.answeredWrong === 0) );

    var curCard = score.curCard;

    // choose a random feedback string from our array of correctFeedback strings
    curCard.feedbackIntro = score.correctFeedback[Math.floor(Math.random() * score.correctFeedback.length)];

    // mark card as completed
    curCard.completed = true;

    // update timesTested for the card
    curCard.timesTested += 1;

    // push the question level for this card's topic (have to do it here, before we update the level below)
    curCard.topic.questionLevels.push(curCard.topic.nextLevel);

    // and update points for the card's topic
    curCard.topic.totalPointsAvailable += Math.round(curCard.originalPointsAvailable);
    curCard.topic.totalPointsEarned += Math.round(curCard.pointsAvailable);

    // Determine next level for this topic, as well as points
    // note that giving up always results in -1; that's handled above

    var question_result;
    // if user took a content hint, add on to numHelps
    var numHints = curCard.numHelps;
    if (curCard.takenContentHint) {
        ++numHints;
    }

    // outcomes depend on question type; first do MC/SC
    if (curCard.questionType === 'MC' || curCard.questionType === 'SC') {
        // no hints, no wrong answers: +1
        if (curCard.answeredWrong === 0 && numHints === 0) {
            question_result = "perfect";  // e.g. not_wrong_no_hints
            changeTopicLevel(curCard, 1);
        }
        // answeredWrong once OR needed one hint (but then got it right): 0
        else if ((curCard.answeredWrong === 1 && numHints === 0)
            || (curCard.answeredWrong === 0 && numHints === 1)) {
            question_result = "one_hint_or_guess";
            changeTopicLevel(curCard, 0);
        }
        // else needed more than one hint and guess: -1
        else {
            question_result = "not_wrong_multiple_hints_or_guesses";
            changeTopicLevel(curCard, -1);
        }
    }
    // FB Questions -- in the current implementation, there's no way to guess FB questions incorrectly
    else {
        // no hints: +1
        if (numHints == 0) {
            question_result = "perfect";  // e.g. not_wrong_no_hints
            changeTopicLevel(curCard, 1);
        }
        // two or fewer hints: 0
        else if (numHints < 2) {
            question_result = "one_or_two_hints";
            changeTopicLevel(curCard, 0);
        }
        // else more than 2 hints: -1
        else {
            question_result = "more_than_two_hints";
            changeTopicLevel(curCard, -1);
        }
    }

    // if user didn't need any hints, increment timesCorrect for the card
    if (numHints == 0) {
        ++curCard.timesCorrect;
    }

    // push the question results for this card's topic
    curCard.topic.questionResults.push(question_result);

    // add points to total and update the score graphics
    curCard.pointsAchieved = Math.round(curCard.pointsAvailable);
    score.activityScore += curCard.pointsAchieved;

    // and update activity grade
    if (score.activityScore >= score.scoreTarget) {
        score.activityGrade = 100;
    }

    // points have been applied for this question, so zero out pointsAvailable
    curCard.pointsAvailable = 0;
}

export function gradeAndScoreWrongAnswer(learningCurve) {
    var score = learningCurve;

    var curCard = score.curCard;

    // choose a random feedback string from our array of incorrectFeedback strings
    curCard.feedbackIntro = score.incorrectFeedback[Math.floor(Math.random() * score.incorrectFeedback.length)];

    if (curCard.questionType === 'FB') {
        score.messageToUser = "Your answer is being checked as you type...";
        return;
    }

    // record that the user got the card wrong
    curCard.answeredWrong += 1;

    // if there's only one choice left, the student can't get any points for the question
    if (curCard.choicesLeft() <= 1) {
        curCard.pointsAvailable = 0;
    } else {
        adjustPointsAvailableForIncorrect(score);
    }
}

export function evaluateMcScAnswer(question) {
    // set grade accordingly
    if (question.userAnswerIndex == question.correctAnswerIndex) {
        question.grade = 100;
        return true;
    }
    // mark this answer as incorrect
    else {
        question.grade = 0;
        return false;
    }
}

export function evaluateFbAnswer(question) {

    // fn to be used for comparing answers
    function answerTransform(s) {
        s = "" + s;
        s = s.toLowerCase();
        s = s.trim(s);
        // remove all spaces in the string
        s = s.replace(/\s/g, '')
        return s;
    }

    // check against any possible answers
    var isCorrect = false;
    for (var j = 0; j < question.answers.length; ++j) {
        // remove spaces and dashes, and normalize case, from both answers for comparison
        var ua = answerTransform(question.userAnswer);
        var ca = answerTransform(question.answers[j]);

        // if ca is a number...
        if (!isNaN(ca * 1)) {

            // see how many decimal places ca has
            var dec = ca.replace(/.*\.(.*)/, "$1");
            var factor = Math.pow(10, dec.length);

            // convert ca to a number
            ca = ca * 1;

            // convert ua to a number and round to the given number of places
            ua = Math.round(factor * ua) / factor;
        }

        if (ca == ua) {
            isCorrect = true;
            break;
        }
    }

    // set grade accordingly
    if (isCorrect) {
        question.grade = 100;
        return true;
    } else {
        question.grade = 0;
        return false;
    }
}

// user gave up, show answer, adjust points, etc.
export function showAnswer(score, curCard, forced) {
    // check time taken to answer the question
    checkQuestionTime(score, false);

    // Note that the user gave up on this one, unless show_answer was forced
    if (forced === false) {
        curCard.givenUp = true;
    }

    curCard.completed = true;
    ++curCard.timesTested;

    // update question_results and question_levels for the card's topic
    curCard.topic.questionResults.push("gave_up");
    curCard.topic.questionLevels.push(curCard.topic.nextLevel);

    // also update the total_points_available for the card's topic
    curCard.topic.totalPointsAvailable += Math.round(curCard.originalPointsAvailable);

    // set the next level for this topic to the next lowest level
    changeTopicLevel(curCard, -1);

    curCard.pointsAvailable = 0;
}

/**
 * Return the next question (aka Card) to show the student.
 *
 * @param activity
 * @param questionIndex force a specific question to be delivered (useful for testing)
 */
export function nextTestCard(activity, questionIndex, config) {
    var nextTopicIndex = 0;
    var nextCard  = null;
    var strategy = _.get(config, 'IRT_STRATEGY', 'dynamic');

    if (activity.config.testMode) {
        activity.score.testModeCardCounter = activity.score.testModeCardCounter >= activity.questions.length-1
          ? 0
          : activity.score.testModeCardCounter+1
        nextCard = activity.questions[activity.score.testModeCardCounter];
    }
    else if (activity.config.topicSelection == "by_number_of_questions") {
        nextTopicIndex = selectTopicByNumberOfQuestions(activity);
        nextCard = getNextCard(activity, nextTopicIndex, strategy);
    }
    // otherwise use the "normal" method
    else {
        nextTopicIndex = selectTopic(activity);
        nextCard = getNextCard(activity, nextTopicIndex, strategy);
    }

    if (isFinite(questionIndex) && questionIndex >= 0) {
        nextCard = activity.questions[questionIndex]
    }

    // nextCard will be null if there are no questions for the given topic
    // normally that's not possible, but sometimes it's handy to filter questions for testing
    if (nextCard === null) {
        console.warn('WARNING: getNextCard returned null (this is ok if you are testing)');
        return null;
    }

    activity.score.messageToUser = checkForMissingTopicLevel(activity);
    activity.score.questionStartTime = Date.now();

    nextCard.pointsAvailable = calculateInitialPointsAvailable(activity.score, nextCard);
    nextCard.originalPointsAvailable = nextCard.pointsAvailable;
    nextCard.pointsAchieved = 0;
    nextCard.answered = [];
    nextCard.hinted = [];
    nextCard.numHelps = 0;
    nextCard.firstAutoHint = false;
    nextCard.takenContentHint = false;
    nextCard.givenUp = false;
    nextCard.answeredWrong = 0;
    nextCard.completed = false;
    nextCard.topic.questionsReceived++;

    activity.score.curCard = nextCard;
    activity.studentData.activity_questions_received++;

    return nextCard;
}

// MS 3/18/2013: PP-2883 (Adding function to show warning message)
export function checkForMissingTopicLevel(learningCurve) {
    var error_msg = '';
    for (var i = 0; i < learningCurve.topics.length; i++) {
        var t = learningCurve.topics[i];

        var val = missingLevel(t.allLevel, t.label);
        if(val != ''){
            error_msg = error_msg + " " + val +"\n";
        }
    }
    return error_msg;

    function missingLevel(allLevel, label) {
        var msg = "Topic '"+ label +"' has no questions at level [ ";
        var level = allLevel.sort();
        var str = '';
        var length = level.length;
        for (var k =1; k <= level[length-1]; k++){
            var val = in_array(level, k);
            if(val == false){
                str = str + k +", ";
            }
        }
        var strlen = str.length ;
        var finalstr = '';
        if (str.substr(strlen-2, strlen) == ", "){
            finalstr = str.substr(0, strlen-2);
        }
        if (finalstr != ''){
            finalstr = msg + finalstr + "]";
        }
        return finalstr;
    }

    function in_array(array, id) {
        for (var i=0;i<array.length;i++) {
            if (array[i] == id) {
                return true;
            }
        }
        return false;
    }
}

export function selectTopicByNumberOfQuestions(learningCurve) {
    var score = learningCurve.score;

    var topicIndex = 0;

    // build up a list of ranges
    var lr = [];
    var ur = [];
    var last_ur = 0;
    for (var i = 0; i < learningCurve.topics.length; ++i) {
        // lower range is 0 or the last upper range
        if (i == 0) {
            lr[i] = 0;
        }
        else {
            lr[i] = ur[i - 1];
        }

        // multiplier is the same for all levels previous to user being half way to score target
        var mult = 100;
        // after that point, we weight by scores
        if (score.activityScore > score.scoreTarget / 2) {
            mult = score.activityScore - learningCurve.topics[i].totalPointsEarned;
        }

        // upper range is lower range + mult * the proportion of questions for this topic
        // returns the proportion of total questions in the activity for one given topic
        var proportionOfTotalQuestions = learningCurve.topics[i].totalQuestions / learningCurve.questions.length;
        ur[i] = lr[i] + mult * proportionOfTotalQuestions;

        // last_ur should get the last upper range
        last_ur = ur[i];
    }

    // now get a random number between 0 and last_ur
    var rn = Math.random() * last_ur;

    // and choose the level that matches that random number
    for (var i = 0; i < learningCurve.topics.length; ++i) {
        if (rn > lr[i] && rn <= ur[i]) {
            topicIndex = i;
            break;
        }
    }

    // debug: report topic chosen
    // console.log("topic chosen: " + (topicIndex + 1) + " (rn=" + Math.round(rn) + " / last_ur=" + last_ur + ")");
    return topicIndex;
}

export function selectTopic(activity) {

    var score = activity.score;
    var topics = activity.topics;
    var questions = activity.questions

    // first topic might be an orphan, so get the first non-orphan topicId
    var topic = _.find(topics, topic => isTopicWithQuestions(topic, questions))
    var topicIndex = topic.topicId

    // if the user is more than half way to the score target, choose based on topic performance
    if (score.activityScore > score.scoreTarget / 2) {
        // LST-1781
        //
        // new algorithm, previous was heavily weighted for first two topics and failed when
        // greater than three topics existed (which is common now in LC)
        //
        // filter valid topics, randomly choose next topic weighted by topic score,
        // where lowest score has greatest chance of selection, and highest the least
        const rn = Math.random();
        const validTopics = topics.filter(t => isTopicWithQuestions(t, questions))
        const sumOfTopicScores = validTopics.reduce((a, b) => a + b.totalPointsEarned, 0)
        const sumOfInvertedTopicScores = validTopics.reduce((a, b) => a + (sumOfTopicScores - b.totalPointsEarned), 0)
        let lr = 0; // lower range
        for (const t of validTopics) {
            // calc inverted score, normalize
            // in case sumOfInvertedTopicScores=0, weight evenly among topics
            const invertedScoreValue = sumOfTopicScores - t.totalPointsEarned;
            const normalizedValue = invertedScoreValue / sumOfInvertedTopicScores || 1 / validTopics.length;
            // calc upper range
            const ur = lr + normalizedValue;
            // between lower and upper range?
            if (rn > lr && rn < ur) {
                // yes, select topic
                topicIndex = topics.indexOf(t);
                break;
            }
            // no, continue to next range
            lr = ur;
        }
    }
    // else round-robin
    else {
        // Reshuffle topics, if we've gone through all topics (or are just starting)
        if (score.topicOrder.length === 0) {
            for (var i = 0; i < topics.length; ++i) {
                if (!isTopicWithQuestions(topics[i], questions)) {
                  score.topicOrder[i] = null;
                } else {
                  score.topicOrder[i] = i;
                }
            }
        }
        // shift the next topic off the beginning of the queue after removing null elements
        score.topicOrder = score.topicOrder.filter(function(index) {
          return typeof index === 'number'
        })
        topicIndex = score.topicOrder.shift();
    }
    return topicIndex;
}

export function isTopicWithQuestions(topic, questions) {
  return questions.some(function(question) {
    return topic.topicId === question.topic.topicId
  })
}

export function getNextCard(learningCurve, topicIndex, strategy) {

    var questions = learningCurve.questions;
    var topics = learningCurve.topics;

    if (strategy === 'sequential') {
        if (!learningCurve.score.curCard) {
            return questions[0]
        }
        return questions[learningCurve.score.curCard.questionIndex + 1]
            ? questions[learningCurve.score.curCard.questionIndex + 1]
            : questions[0]
    }

    // pull a card for the chosen topic and the topic's level
    var next_topic = topics[topicIndex];
    var level = next_topic.nextLevel

    // level might be a fraction; round it up
    level = Math.round(level + 0.01); // probably not necessary to add 0.01, but do it to be safe

    // create an array with all questions for this level and topic
    // if we find a question marked as a "primary_question", use it without further checking
    var pc =[]; // possible cards
    for (var i = 0; i < questions.length; ++i) {
        var f = questions[i];

        // if the question is for the topic we want...
        if (f.topic.label === next_topic.label) {
            // then if it's marked as a primary_question...
            if (f.meta.primary_question ==  "true") {
                // mark it as "delivered", so that it won't be delivered first again the next time we're here
                f.meta.primary_question = "delivered";
                // and return it
                return f;
            }

            // otherwise if it's at the right level, push onto the array
            if (f.meta.level == level) {
                pc.push(f);
            }
        }
    }

    // if we found no possible cards...
    if (pc.length == 0) {
        return null;
    }

    // now sort using a fn that:
    // first compares # of times tested (lowest first)
    // then uses # of times correct as second tiebreaker (lowest first)
    // then uses random values as third tiebreaker
    pc.sort(cardSort);

    // then all we have to do is return the first item from the list
    return pc[0];
}

export function cardSort(a, b) {
    // first sort by timesTested -- lower values should be lower in the sort
    if (a.timesTested != b.timesTested) {
        // if a = 2 and b = 1, b should come before a, so we want a positive number
        if (a.timesTested > b.timesTested) {
            return 1;
        } else {
            return -1;
        }
    }
    // then by timesCorrect -- lower values should be higher in the sort
    else if (a.timesCorrect != b.timesCorrect) {
        // if a = 2 and b = 1, b should come before a, so we want a positive number
        if (a.timesCorrect > b.timesCorrect) {
            return 1;
        }
        else {
            return -1;
        }
    }
    // then randomly
    else {
        return (Math.random() - .5);
    }
}

/*
curCard.md means metadata.  md keys come from any keys that begin with underscore in the LC definition file
 */
export function calculateInitialPointsAvailable(score, curCard) {
    // PW: I'm not sure about this...
    // I don't know where this "score" value is really coming from,
    // and in any case we may want to ignore this data and use the standard point values
    // for all MC/SC and FB questions.

    // joliver: this came from px DLAP system, I think it's obsolete
    var defaultScore = -1;

    var pointsAvailable = 0;

    if (curCard.score > 0) {
        pointsAvailable = curCard.score;
    }
    else if (defaultScore > 0) {
        pointsAvailable = defaultScore;
    }
    // MC/SC
    else if (curCard.questionType === 'MC' || curCard.questionType === 'SC') {
        pointsAvailable = 5 + (10 * curCard.meta.level);
    }
    // FB
    else {
        pointsAvailable = 10 + (10 * curCard.meta.level);
    }

    // multiply by initialPointsReductionFactor -- prevention for cheating
    pointsAvailable *= score.initialPointsReductionFactor;
    return pointsAvailable;
};

export function checkQuestionTime(score, correctFirstTime) {

    if (score.questionStartTime == null) {
        return;
    }

    var qt = Date.now() - score.questionStartTime;

    // if the student was incorrect and too quick...
    if (!correctFirstTime && qt < score.minQuestionConsiderationTime) {
        // slow him down with an alert -- but not every time
        if (score.reductionsSinceLastWarning == 0) {
            score.messageToUser = "You went through that last question awfully quickly. Slow down a bit and consider each question carefully.";
        }

        score.reductionsSinceLastWarning = (score.reductionsSinceLastWarning + 1) % 6;

        // and reduce the number of points he can get on the next question
        score.initialPointsReductionFactor *= .7;
        if (score.initialPointsReductionFactor < score.initialPointsReductionFactorMin) {
            score.initialPointsReductionFactor = score.initialPointsReductionFactorMin;
        }

        // show a different warning if the penalty has gotten low
        if (score.reductionsSinceLastWarning == 3 && score.initialPointsReductionFactor < .5) {
            score.messageToUser = "Note that the potential points you can earn for answering questions has been reduced because you are guessing too quickly. If you slow down, this penalty will be removed.";
        }
    }
    else {
        // reduce the penalty, but not beyond the min
        score.initialPointsReductionFactor *= 1.5;
        if (score.initialPointsReductionFactor > 1) {
            score.initialPointsReductionFactor = 1;
        }
    }
}

export function changeTopicLevel(curCard, delta) {
    var t = curCard.topic;

    // see what level we're supposed to move up to
    var nl = Math.round(t.nextLevel + delta);

    // only move to that level if there are actually questions at that level for the topic;
    // otherwise we stay at the level given
    if (t.levelCount[nl] != null) {
        t.nextLevel = nl;
    }
}

export function adjustPointsAvailableForIncorrect(score) {
    // MC/SC: reduce by 65%
    if (score.curCard.questionType === 'MC' || score.curCard.questionType === 'SC') {
        score.curCard.pointsAvailable = score.curCard.pointsAvailable * .35;

        // You can't actually get a FB wrong
    }

    return percentPointsAvailable(score);
}

export function adjustPointsAvailableForContentHint(score) {
    // reduce by 50% (for all question types)
    score.curCard.pointsAvailable = score.curCard.pointsAvailable * .5;
    return percentPointsAvailable(score);
}

export function adjustPointsAvailableForAutoHint(score) {
    var curCard = score.curCard;
    // MC/SC: reduce by 60%
    if (curCard.questionType === 'MC' || curCard.questionType === 'SC') {
        score.curCard.pointsAvailable = score.curCard.pointsAvailable * .4;
    }
    // FB:
    else {
        // After first hint: reduce by 30%
        if (curCard.firstAutoHint == false) {
            score.curCard.pointsAvailable = score.curCard.pointsAvailable * .7;
        }
        // For subsequent hints: reduce by 15%
        else {
            score.curCard.pointsAvailable = score.curCard.pointsAvailable * .85;
        }
    }
    curCard.firstAutoHint = true;

    return percentPointsAvailable(score);
}

// returns percent of points available for answering the current question correctly?
export function percentPointsAvailable(score) {
    var potential = score.activityScore + score.curCard.pointsAvailable;
    var p = potential / score.scoreTarget * 100;
    if (p > 100) {
        p = 100;
    }
    return Math.round(p);
}

// joliver: not necessarily needed in the engine since it's a client side calculation
// returns percent of this Learning Curve's total activity score achieved.
// Once this value is >= 100, the activity is complete.
export function percentScore(score) {
    var p = score.activityScore  / score.scoreTarget * 100;
    if (p > 100) {
        p = 100;
    }
    return Math.round(p);
}

export function doHelp(score) {
    var curCard = score.curCard;
    var help_text = "";
    var hinted_answer_index;

    if (curCard.meta.content_hint != null && curCard.takenContentHint === false) {
        help_text = "<b>Hint</b> &nbsp; " + curCard.meta.content_hint;
        curCard.takenContentHint = true;

        // update points available
        adjustPointsAvailableForContentHint(score);
    }
    else if ((help_text = flashcardHelp()) != false) {
        help_text = "<b>Hint</b> &nbsp; " + help_text;

        if (curCard.questionType === 'MC' || curCard.questionType === 'SC') {
            var choice_fb = curCard.choices_fb[hinted_answer_index];
            if (choice_fb != null) {
                // take out page references
                choice_fb = choice_fb.replace(/(.*)\{\{(.*)\}\}/, "$1");
            }
            if (choice_fb != null && choice_fb != "") {
                help_text += "<div class='feedback_answer_choice_specific'><b>&rarr;</b> " + choice_fb + "</div>";
            }
        }

        ++curCard.numHelps;

        // update points available
        adjustPointsAvailableForAutoHint(score);

    } else {
        help_text = "<b>Sorry!</b> No more hints available. Click the \"Show Me\" button if you're stumped.";
    }

    return help_text;


    function flashcardHelp(q) {

        if (q.numHelps <= q.choices.length - 2) {
            // if no helps left, return false
            return false;
        }
        // user gets help on a mc question by eliminating choices until there are two left
        var fb = "Sorry, this feature is not currently available";

        return fb;
    };
}

export function getPageId(bookId, s) {
    // if the ebook md field includes [[xx]] at the end, xx is the full page id
    if (s.search(/\s*\[\[(.*)\]\]\s*/) > -1) {
        return RegExp.$1;
    }
    // else look for a section number at the start, and if we find one...
    else if (s.search(/^([\d\.]+)/) > -1) {
        var pageid = RegExp.$1.toString();
        // if pageid is empty, just return it.
        if (pageid === '') {
            return '';
        }

        // convert "." to "_"
        pageid = pageid.replace(/\./g, "_");
        // get rid of any trailing "_"
        pageid = pageid.replace(/_+$/, "");

        // and return this tacked onto the end of book_id
        bookId = bookId !== null ? bookId : '';
        return bookId + "_" + pageid;
    }
    else {
        return null;
    }
}

export function getEbookRef(curCard) {
    if (curCard == null) {
        return "unknown";
    }
    else if (curCard.meta.ebook != null) {
        return curCard.meta.ebook;
    }
    // then look for ebook sections in the topic
    else if (curCard.topic.ebookSections.length > 0) {
        return curCard.topic.ebookSections[0];
    }
    // use topic by default
    else if (curCard.topic != null) {
        return curCard.topic.label;
    }
    else {
        return "unknown";
    }
}

export function getEbookPageIdForCurrentQuestion(lc) {
    return getPageId(lc.bookId, getEbookRef(lc.score.curCard));
}

export function calculateOverallTopicAccuracy (topics, selectedStudentIndex) {
    var totalPointsAvailable = 0;
    var totalPointsEarned = 0;
    topics.forEach(topic => {
        if (selectedStudentIndex >= 0) {
            var pa = isFinite(topic.pa_arr[selectedStudentIndex]) ? topic.pa_arr[selectedStudentIndex] * 1 : 0;
            var pe = isFinite(topic.pe_arr[selectedStudentIndex]) ? topic.pe_arr[selectedStudentIndex] * 1 : 0;
            totalPointsAvailable += pa;
            totalPointsEarned += pe;
        }
        else {
            // we can't use pa_arr or pe_arr for student class performance because they may contain instructor data
            totalPointsAvailable += topic.class_points_available * 1;
            totalPointsEarned += topic.class_points_earned * 1;
        }
    })

    return totalPointsAvailable > 0 && totalPointsEarned > 0
      ? Math.round(100 * totalPointsEarned / totalPointsAvailable)
      : 0
}
